/**
 * @description
 * Objeto IsProveidor
 */

export class IsProveidor {
    
    public isproveedor : boolean;
    public error: String;
  
    constructor() {}
  
}